"use client"

import React, { useEffect, useState } from "react"
import FsLightbox from "fslightbox-react"

interface hotProps {
  lang: string
}

const OurHottestVideos: React.FC<hotProps> = ({ lang }) => {
  const [translations, setTranslations] = useState<any>(null)

  const [toggler, setToggler] = useState<boolean>(false)
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0)
  const videos = [
    "https://www.youtube.com/embed/rCl-0qgzmJQ",
    "https://www.youtube.com/embed/WgIulMhrZbY",
    "https://www.youtube.com/embed/KZwmhB4uKY4",
  ]

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const response = await fetch(`/api/translations/${lang}`)
        const data = await response.json()
        setTranslations(data)
      } catch (error) {
        console.error("Failed to fetch translations:", error)
      }
    }
    fetchTranslations()
  }, [lang])

  if (!translations) {
    return null
  }

  return (
    <>
      {/* Use here youtube Embed video link */}
      <FsLightbox
        toggler={toggler}
        sources={videos}
        sourceIndex={selectedVideoIndex}
      />

      <div className="the-video-area pt-175 pb-150">
        <div className="container">
          <div className="section-title left-title mb-70">
            <span className="top-title">
              {translations.app?.hot?.title || "LOS VIDEOS"}
            </span>
            <h2>
              {translations.app?.hot?.subtitle ||
                "Algunos videos mostrandos nuestros predios."}
            </h2>
          </div>

          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div
                className="video-songle-item position-relative"
                style={{
                  backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_260,f-auto,q_auto/SAM_7747_msnqqt_wHZyrd9ay )`,
                  height: "260px",
                }}
              >
                <div
                  className="video-btn position-absolute top-50 start-50 translate-middle"
                  onClick={() => {
                    setSelectedVideoIndex(0)
                    setToggler(!toggler)
                  }}
                >
                  <i className="ri-play-fill"></i>
                </div>
              </div>

              <div
                className="video-songle-item position-relative"
                style={{
                  backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_260,f-auto,q_auto/SAM_7768_hcenea_OvK3Euz6U )`,
                  height: "260px",
                }}
              >
                <div
                  className="video-btn position-absolute top-50 start-50 translate-middle"
                  onClick={() => {
                    setSelectedVideoIndex(1)
                    setToggler(!toggler)
                  }}
                >
                  <i className="ri-play-fill"></i>
                </div>
              </div>
            </div>

            <div className="col-lg-8 col-md-8">
              <div
                className="video-songle-item position-relative"
                style={{
                  backgroundImage: `url(https://ik.imagekit.io/dghnzttwq/tr:w,h_540,f-auto,q_auto/SAM_7714_ymxbcn_vOelsP8EZ )`,
                  height: "540px",
                }}
              >
                <div
                  className="video-btn v-btn position-absolute top-50 start-50 translate-middle"
                  onClick={() => {
                    setSelectedVideoIndex(2) // Set index for the first video
                    setToggler(!toggler)
                  }}
                >
                  <i className="ri-play-fill"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OurHottestVideos
